module.exports = __webpack_public_path__ + "img/携程_01.1cd475b6.jpg";